<template>
  <div v-if="accommodaties" class="mt-4">
    <table class="w-full">
      <tr class="bg-mi-blue-500 text-gray-100">
        <th class="text-left">Naam</th>
        <th class="text-left">Adres</th>
        <th class="text-left">Plaats</th>
        <th class="text-left">Gemeente</th>
      </tr>

      <tr
        v-for="(acc, index) in accommodaties"
        :key="acc.id"
        @click="openAccomm(acc.id)"
        class="hover:text-mi-blue-500 cursor-pointer"
        :class="{ 'bg-gray-200': index % 2 === 0 }"
      >
        <td>{{ acc.naam }}</td>
        <td>{{ acc.adres }}</td>
        <td>{{ acc.plaats }}</td>
        <td>{{ acc.gemeente }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { sortByAttr } from "../../common/utils.js";
export default {
  name: "TableView",
  computed: {
    accommodaties() {
      if (!this.$store.state.backend_data_loaded) return [];
      return sortByAttr(
        this.$store.state.backend_data.accommodaties["results"],
        "name"
      ).slice(0, 20);
    },
  },
  methods: {
    openAccomm: function (id) {
      this.$router.push({ name: "Accommodatie", params: { id: id } });
    },
  },
};
</script>

<style scoped>
li {
  list-style: none;
  display: block;
  border-width: 2px;
  border-style: solid;
  border-color: darkgray;
  margin: 1em;
  padding: 1em;
}

li a {
  text-decoration: none;
  color: inherit;
}

li:hover {
  background-color: lightgray;
}

li:hover a {
  text-decoration: underline;
}
</style>
